import { useApi } from "../utils/apiUtils";

const useUpdateQuestionnaireMetadata = () => {
  const { apiPatch } = useApi();
  const updateMetadata = async (id, formData) => {
    const result = await apiPatch(`/questionnaires/${id}/update_metadata`, " Hubo un error al actualizar la metadata del cuestionario", { formData });
    return !result.error;
  };
  return updateMetadata;
};

export default useUpdateQuestionnaireMetadata;
